export class Translations {
    hsm: {
        navbar: string;
        backToOverview: string;
        createHomeworkButton: string;
        formHeadline: string;
    };
}

export const defaultTranslations = {
    hsm: {
        navbar: 'HÜ/SÜ',
        backToOverview: 'Meine Übungen',
        createHomeworkButton: 'Übung erstellen',
        sidebarHeadline: 'Haus- und Schulübungen',
        formHeadline: 'Neue Übung erstellen',
        openFormButton: 'Neue Übung',
        studentForeignHomeworks: 'Schul- & Hausübungen',
        studentOwnHomeworks: 'Selbst erstellte Übungen',
        homework: 'Übung',
        homeworks: 'Übungen'
    }
};

export const hoelzelTranslations = {
    hsm: {
        navbar: 'Aufgaben',
        backToOverview: 'zur Aufgabenübersicht',
        createHomeworkButton: 'Aufgabe erstellen',
        sidebarHeadline: 'Aufgaben',
        formHeadline: 'Neue Aufgabe erstellen',
        openFormButton: 'Neue Aufgabe erstellen',
        studentForeignHomeworks: 'Meine Aufgaben',
        studentOwnHomeworks: 'Selbst erstellte Übungen',
        homework: 'Aufgabe',
        homeworks: 'Aufgaben'
    }
};
